export default __webpack_public_path__ + "static/media/background_information.6e6748e1.svg";